export default __webpack_public_path__ + "static/media/guasasapo-sello-granada-invertido.b6c95fa6.png";